export const SITE = {
  brand: "petrahcollection",
  displayName: "Petrah Collection",
  legalName: "Petrah Collection Store",
  tagline: "Fresh footwear, standout looks, and customer care you can trust.",
  heroTitle: "Step out in style with Petrah Collection.",
  heroSubtitle:
    "Shop sneakers, official shoes, boots, slip-ons, sports shoes, and more from our OTC Wholesale Mall shop or online.",
  phoneDisplay: "+254 745 833965",
  phoneHref: "tel:+254745833965",
  whatsappNumber: "254745833965",
  email: "petrahcollection2026@gmail.com",
  locationTitle: "OTC WHOLESALE MALL",
  locationLine: "2nd floor- F2C-073",
  fullLocation: "OTC WHOLESALE MALL, 2nd floor- F2C-073",
  instagram: "https://www.instagram.com/petrahcollection?igsh=MWprOHl1MnpkaTBh",
  tiktok: "https://www.tiktok.com/@petrah0372?_r=1&_t=ZS-96DQe0Mq5Tu",
  businessHours: "Monday - Saturday, 07:00 - 19:00",
  businessHoursDetailed: "Monday - Saturday, 07:00 - 19:00\nSunday - Closed",
  deliveryNote: "Quick Nairobi delivery and easy order support on WhatsApp.",
  defaultWhatsAppMessage: "Hi Petrah Collection, I would like to place an order.",
};

export const CATEGORY_LINKS = [
  ["Home", "/"],
  ["Men", "/men-shoes"],
  ["Women", "/women-shoes"],
  ["Kids", "/kids-shoes"],
  ["Sneakers", "/sneakers"],
  ["Sports", "/sport-shoes"],
  ["Official", "/official-shoes"],
  ["Boots", "/boots"],
  ["Slip-Ons", "/slip-on-shoes"],
  ["Brands", "/brands"],
  ["Contact", "/contact-us"],
];

export const HOME_COLLECTIONS = [
  {
    title: "Sneakers",
    description: "Street-ready pairs with bold comfort and everyday versatility.",
    to: "/sneakers",
  },
  {
    title: "Official Shoes",
    description: "Clean finishing for office wear, events, and polished fits.",
    to: "/official-shoes",
  },
  {
    title: "Boots",
    description: "Durable statement styles built for edge, grip, and confidence.",
    to: "/boots",
  },
  {
    title: "Sports",
    description: "Performance-focused shoes for active days and quick movement.",
    to: "/sport-shoes",
  },
];

export function createWhatsAppLink(message = SITE.defaultWhatsAppMessage) {
  return `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(message)}`;
}
